import React, { createContext, useContext } from 'react';

import type { Entity, Evaluation } from '~/entities/types';

export interface EventTypeEvaluationsContextType {
  evaluation: Evaluation;
  entity: Entity;
  categories: Array<{ name: string }>;
  isJourneyApplicationPage: boolean;
  isInvestigationPage: boolean;
  updateSelectedServiceResponse: () => void;
  constructWatchlistMatchDataObject: (final_response: Evaluation['final_response']) => object[];
  children?: React.ReactNode;
}

export const EventTypeEvaluationsContext = createContext<EventTypeEvaluationsContextType>({
  evaluation: {} as Evaluation,
  entity: {} as Entity,
  categories: [],
  isJourneyApplicationPage: false,
  isInvestigationPage: false,
  updateSelectedServiceResponse: () => {},
  constructWatchlistMatchDataObject: () => [],
});

export const EventTypeEvaluationsProvider: React.FC<EventTypeEvaluationsContextType> = props => {
  const { children, ...value } = props;

  return (
    <EventTypeEvaluationsContext.Provider
      value={value}
    >
      {children}
    </EventTypeEvaluationsContext.Provider>
  );
};

export const useEventTypeEvaluationsContext = () => useContext(EventTypeEvaluationsContext);
